/**
 * Initialise Google Analytics de manière dynamique
 */
export const initGoogleAnalytics = () => {
  const measurementId = 'G-1P2WH9YZEE'

  // Vérifier si le script n'est pas déjà chargé
  if (
    document.querySelector(
      `script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`,
    )
  ) {
    return
  }

  // Créer et insérer le script GA
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', measurementId)

  window.gtag = gtag
}
